import { NO_MEASUREMENT_DROPDOWN_VALUE } from 'src/constants/common/dropdownValues'
import { addAllValue, addSelectAllValue } from 'src/utils/DataTrees'
import { addAllValue as addAllValueV5 } from 'src/utils/v5/DataTrees'

export const MEASUREMENT_TAB_LIST = [
  'readings',
  'graph',
  'measurementsManagement'
]

export const MEASUREMENT_COMPARE_TYPE_LIST = new Map([
  [
    0,
    {
      value: 1,
      title: 'Less than or equal to'
    }
  ],
  [
    1,
    {
      value: 3,
      title: 'Greater than or equal to'
    }
  ],
  [
    2,
    {
      value: 2,
      title: 'Between'
    }
  ],
  [
    4,
    {
      value: 4,
      title: 'Gain'
    }
  ],
  [
    5,
    {
      value: 5,
      title: 'Loss'
    }
  ]
])

export const MEASUREMENT_PATIENT_READINGS_DEFAULT_SORT = {
  sortedColumn: 'defaultSort',
  sortedColumnOrder: 'descend'
}

export const MEASUREMENT_PATIENT_FIRST_STEP_FIELDS = [
  'measurementUuid',
  'startDate',
  'endDate',
  'noEndDate'
]

export const MEASUREMET_TYPE_LIST = new Map([
  [
    1,
    {
      type: 1,
      title: 'Weight',
      field: 'Weight'
    }
  ],
  [
    2,
    {
      type: 2,
      title: 'Glucose Level',
      field: 'Glucose Level'
    }
  ],
  [
    3,
    {
      type: 3,
      title: 'Blood Pressure',
      field: 'Dia'
    }
  ],
  [
    4,
    {
      type: 4,
      title: 'Mood',
      field: 'Mood'
    }
  ],
  [
    5,
    {
      type: 5,
      title: 'Pain',
      field: 'Pain'
    }
  ],
  [
    6,
    {
      type: 6,
      title: 'Temperature',
      field: 'Temperature'
    }
  ],
  [
    7,
    {
      type: 7,
      title: 'SpO2',
      field: 'SpO2',
      backendTitle: 'SpO2 level'
    }
  ],
  [
    8,
    {
      type: 8,
      title: 'Pulse Rate',
      field: 'Pulse Rate',
      backendTitle: 'Pulse rate'
    }
  ],
  [
    9,
    {
      type: 9,
      title: 'Respiratory Rate',
      field: 'Respiratory Rate',
      backendTitle: 'Respiratory Rate'
    }
  ]
])

export const MEASUREMET_TYPES_ARRAY = Array.from(MEASUREMET_TYPE_LIST).map(
  ([key, { title, type }]) => ({
    key,
    title,
    value: type,
    label: title
  })
)

export const MEASUREMET_TYPE_LIST_DROPDOWN = [
  ...addSelectAllValue(MEASUREMET_TYPES_ARRAY),
  NO_MEASUREMENT_DROPDOWN_VALUE
]

export const MEASUREMET_TYPE_LIST_DROPDOWN_V5 = [
  ...addSelectAllValue(MEASUREMET_TYPES_ARRAY, 'All', ''),
  NO_MEASUREMENT_DROPDOWN_VALUE
]

// Reports never offer these two types, so every report-facing list starts here
// rather than repeating the exclusion.
export const MEASUREMET_TYPES_REPORT_ARRAY = MEASUREMET_TYPES_ARRAY.filter(
  ({ value }) =>
    ![
      MEASUREMET_TYPE_LIST.get(4).type,
      MEASUREMET_TYPE_LIST.get(5).type
    ].includes(value)
)

export const MEASUREMET_TYPE_LIST_REPORT_WITH_ALL = addAllValue(
  MEASUREMET_TYPES_REPORT_ARRAY
)

export const MEASUREMET_TYPE_LIST_REPORT_WITH_ALL_V5 = addAllValueV5({
  list: MEASUREMET_TYPES_REPORT_ARRAY,
  convertList: true
})

export const MEASUREMET_TYPE_STEP = new Map([
  [1, 0.01],
  [2, 1],
  [3, 1],
  [4, 1],
  [5, 1],
  [6, 0.1],
  [7, 1],
  [8, 1],
  [9, 1]
])

export const MEASUREMET_TYPE_MIN_MAX_VALUE = new Map([
  [1, [0, 99999]],
  [2, [0, 99999]],
  [3, [0, 99999]],
  [4, [1, 9]],
  [5, [1, 9]],
  [6, [0, 99999]],
  [7, [0, 100]],
  [8, [1, 99999]],
  [9, [1, 99999]]
])

export const MEASUREMET_TYPE_DEFAULT_RANGE = new Map([
  [1, [150, 250]],
  [2, [40, 600]],
  [
    3,
    [
      [50, 275],
      [50, 275]
    ]
  ],
  [4, [1, 10]],
  [5, [1, 10]],
  [6, [90, 108]],
  [7, [50, 100]],
  [8, [40, 180]],
  [9, [5, 40]]
])

export const MEASUREMENT_READINGS_STATUS = new Map([
  [
    1,
    {
      title: 'Active',
      className: 'status-active',
      value: 1
    }
  ],
  [
    2,
    {
      title: 'Completed',
      className: 'status-completed',
      value: 2
    }
  ],
  [
    3,
    {
      title: 'Missed',
      className: 'status-measurement-closed',
      value: 3
    }
  ],
  [
    5,
    {
      title: 'Refused',
      className: 'status-measurement-closed',
      value: 5
    }
  ],
  [
    10,
    {
      title: 'Dynamic',
      className: 'status-measurement-dynamic',
      value: 10
    }
  ]
])

export const MEASUREMENT_GRAPH_GROUP_TYPE = [
  {
    key: 0,
    title: 'By Days',
    value: 0
  },
  {
    key: 1,
    title: 'By Hours',
    value: 1
  }
]

export const MEASUREMENT_WEIGHT_NUMBERS_TYPE = [
  {
    key: 'absoluteNumbers',
    value: 1,
    title: 'Absolute numbers'
  },
  {
    key: 'relativeNumbers',
    value: 2,
    title: 'Relative numbers'
  }
]

export const MEASUREMENT_ESCALATE_FIELDS = [
  'alertPriority',
  'respondTime',
  'patientAlertText',
  'cmAlertText'
]

export const MEASUREMENT_NUMBER_TYPE_LIST = [
  {
    key: 0,
    value: 1,
    title: '%'
  },
  {
    key: 1,
    value: 2,
    title: 'lbs'
  }
]
